import axios from 'axios'
import store from '@/store'

export default {
  getExpensesCategories () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/expensesCategory', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          ({ data }) => {
            store.dispatch('setExpensesCategories', data)
            resolve(true)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getExpensesStatuses () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/expenses-statuses', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          ({ data }) => {
            store.dispatch('setExpensesStatuses', data)
            resolve(true)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getExpenses (params) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/expenses', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          },
          params
        })
        .then(
          res => {
            store.dispatch('finances/setExpenses', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getLastExpensePreFillData () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/expense-last-created', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createExpenses (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/expenses`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  updateExpenses (id, params) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/finances/expenses/${id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeExpenses (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/finances/expenses/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
